import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface CollapseIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function CollapseIcon({ className, ...props }: CollapseIconProps) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-5', className)}
      aria-hidden="true"
      {...props}
    >
      <path d="M1.45161 14.1667C1.45161 14.6269 1.12666 15 0.725807 15C0.324956 15 8.22882e-07 14.6269 8.40126e-07 14.1667L1.33968e-06 0.833333C1.35693e-06 0.373096 0.324956 -2.04421e-08 0.725808 0C1.12666 5.93116e-07 1.45161 0.373096 1.45161 0.833333L1.45161 14.1667ZM14.2742 6.66667C14.675 6.66667 15 7.03976 15 7.5C15 7.96024 14.675 8.33333 14.2742 8.33333L5.74975 8.33333L8.52823 11.4497C8.81485 11.7713 8.82057 12.2989 8.54051 12.628C8.26041 12.9572 7.80092 12.9626 7.51418 12.6411L3.46081 8.0957C3.32117 7.93892 3.2425 7.72426 3.2425 7.5C3.2425 7.27574 3.32117 7.06107 3.46081 6.9043L7.51418 2.35894C7.80092 2.03735 8.26041 2.04275 8.54051 2.37196C8.82057 2.70115 8.81485 3.22874 8.52823 3.55035L5.74975 6.66667L14.2742 6.66667Z" fill="currentColor" />
    </svg>
  );
}
